import { DraftFormPopupContainer } from '../../Draft'
import {
  useRequestCreationFormConfirmation,
  useRequestWizardDraft,
} from '../Request.hooks'

function RequestWizardFormPopupContainer({
  getDraftPayload,
  title,
  onClose,
  onSubmitConfirm,
  ...containerProps
}) {
  const { getLatestDraft, setDraft } = useRequestWizardDraft()

  const { Confirmation, handleSubmitConfirm } =
    useRequestCreationFormConfirmation({
      getDraftPayload,
      useDraft: useRequestWizardDraft,
      onClose,
      onSubmitConfirm,
    })

  return (
    <DraftFormPopupContainer
      {...containerProps}
      Confirmation={Confirmation}
      getDraftPayload={getDraftPayload}
      getLatestDraft={getLatestDraft}
      setDraft={setDraft}
      titleKey={title}
      onClose={onClose}
      onSubmitConfirm={handleSubmitConfirm}
    />
  )
}

export default RequestWizardFormPopupContainer
